module.exports = __webpack_public_path__ + "static/feature_marty-5eacc34cd1a23a7efce199f97b4efd75.jpg";